// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__vGBY8","summary":"CartItem_summary__2_dGU","price":"CartItem_price__3bUkj","amount":"CartItem_amount__289dX","actions":"CartItem_actions__1xkDC"};